import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Card } from '@mui/material';
import { isEqual } from 'lodash';

import ApprovalHierarchyGridView from './ApprovalHierarchyGridView';
import MasterServices from './ApprovalHierarchyMasterServices';
import LoadingScreen from '../../../components/loading-screen/LoadingScreen';

import ApprovalHierarchyCommonButtons from './ApprovalHierarchyCommonButtons';
import ApprovalHierarchyAdd from './ApprovalHierarchyAdd';
import ApprovalHierarchyEdit from './ApprovalHierarchyEdit';
import ApprovalHierarchyFilter from './ApprovalHierarchyFilter';
import ApprovalHierarchyHeader from './ApprovalHierarchyHeader';
import PopUpHandle from '../../../commons/PopUpHandle';
import { useAppStore } from '../../../store/appStore';


export default function ApprovalHierarchyMaster() {
    const [requiredFilterData, getRequiredData] = useState([]);
    const [isFilterOpen, setFilterOpen] = useState(false); // Define state for filter modal
    const [isLoading, setIsLoading] = useState(false);
    const { masterName, pageType } = useParams();



    const [open, setOpen] = useState(false);
    const [error, setError] = useState(0);
    const [errorCode, setErrorCode] = useState(null);

    function formatPageName(pageName) {
        const cleanedPageName = pageName ? pageName.trim().replace(/-/g, ' ') : '';
        const formattedPageName = cleanedPageName.replace(/\b\w/g, char => char.toUpperCase());
        return formattedPageName;
    }
    const number = sessionStorage.getItem("number");
    const pageName = formatPageName(masterName);

    const {
        moduleName,
        setModuleName,
        destroy,
        setSearchControls,
        searchControls,
        setResponseData,
        responseData,
        setFilteredData,
        filteredData,
        isListChanged,
        setIsListChanged,
        initialize,
        filterPayload

    } = useAppStore();

    useEffect(() => {
        if (moduleName !== pageName) {
            destroy(); //  this resets the entire store to initial state
            initialize();
            setResponseData(null);
            setModuleName(pageName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleName]);
    
    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            let data;
            try {
                if (filterPayload) {
                    data = await MasterServices.SearchApprovalHierarchy(filterPayload);
                } else {
                     data = await MasterServices.SearchApprovalHierarchy([]);
                }
                setResponseData(data);
                setFilteredData(data);
                setIsListChanged(false);

            } catch (err) {
                if (err?.response?.data?.error?.code === 404 || err?.response?.data?.error?.message === 'Data not found.') {
                    setFilteredData({ ...responseData, Data: [] });
                    setResponseData({ ...responseData, Data: [] });
                }
                console.error('Error fetching data:', err);
                if (err?.response?.data?.error?.code === 404 || err?.response?.data?.error?.message === 'Data not found.') {
                    //
                } else {
                    console.error('Error fetching search controls:', err);
                    setErrorCode(err?.response?.data?.error?.code);
                    setError(err?.response?.data?.error?.message);
                    setOpen(true);
                }
            } finally {
                setIsLoading(false);
            }
         
        };
        if (moduleName != null && isListChanged && (pageType !== 'add' && pageType !== 'edit')) {
            fetchData();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleName]);

    

    useEffect(() => {
        const fetchSearchControls = async () => {
            try {
                const data = await MasterServices.GetApprovalHierarchySearchControls();
                setSearchControls(data);
            } catch (err) {

                console.error('Error fetching data:', err);
                if (err?.response?.data?.error?.code === 404 || err?.response?.data?.error?.message === 'Data not found.') {
                    //
                } else {
                    console.error('Error fetching search controls:', err);
                    setErrorCode(err?.response?.data?.error?.code);
                    setError(err?.response?.data?.error?.message);
                    setOpen(true);
                }
            }
        };   
        if (
            moduleName != null && (searchControls.length === 0 || isListChanged) &&
            (pageType !== 'add' && pageType !== 'edit')) {
            fetchSearchControls();

        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleName, isListChanged]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleFilterChange = (filterValues) => {
        
        if (filterValues.length === 0) {
            setFilteredData(responseData);
            setIsListChanged(false);
            return;
        } 
        const apiError = ['error'];
        if (isEqual(filterValues, apiError)) {
            const tempData1 = { ...filteredData, Data: [] };
            setFilteredData(tempData1);
            setIsListChanged(false);
            return;
        }
        if (filterValues !== apiError) {
            setFilteredData(filterValues);
            setIsListChanged(false);
        }
    };
    const handleOpenFilter = () => {
        setFilterOpen(true);
    };

    const handleCloseFilter = () => {
        setFilterOpen(false);
    };


    const buttons = ApprovalHierarchyCommonButtons(pageName, filteredData, handleOpenFilter, responseData?.View);

    return (
        <Card sx={{
            paddingTop: '10px',
            paddingLeft: '10px',
            paddingRight: '10px',
            paddingBottom:'2px',
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px', // Add rounded corners 
            margin: '5px 3px 2px 3px',
            height: '100%',

            display: 'flex',
            flexDirection: 'column',
            flexGrow: 1,
            
        }}>
            <Box sx={{
                 display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                minHeight: 0,
            }}>
                
                {!pageType && <ApprovalHierarchyHeader headerName={pageName} buttons={buttons} requiredFilterData={requiredFilterData} seachFilterData={requiredFilterData} />}
                 <ApprovalHierarchyFilter
                    open={isFilterOpen}
                    onClose={handleCloseFilter}
                    onFilterChange={handleFilterChange}
                    pageName={pageName}
                    searchControls={searchControls}
                    getRequiredData={getRequiredData}
                /> 
                {!pageType && <ApprovalHierarchyGridView data={filteredData} headerName={pageName} />}
                
                {pageType === 'add' && <ApprovalHierarchyAdd />}
                 {pageType === 'edit' && <ApprovalHierarchyEdit />} 
                { isLoading && <LoadingScreen />}
                {open && (<PopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode} />)}
            </Box>
        </Card>
    );
}
